/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connect_A_Domain_You_Already_OInputs */

const en_connect_a_domain_you_already_o = /** @type {(inputs: Connect_A_Domain_You_Already_OInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect a domain you already own from providers like GoDaddy, Namecheap, or Google Domains.`)
};

const es_connect_a_domain_you_already_o = /** @type {(inputs: Connect_A_Domain_You_Already_OInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecta un dominio que ya poseas (de proveedores como GoDaddy, Namecheap o Google Domains).`)
};

const fr_connect_a_domain_you_already_o = /** @type {(inputs: Connect_A_Domain_You_Already_OInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez un domaine que vous possédez déjà (chez des fournisseurs comme GoDaddy, Namecheap ou Google Domains).`)
};

const de_connect_a_domain_you_already_o = /** @type {(inputs: Connect_A_Domain_You_Already_OInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinde eine Domain, die du bereits besitzt (von Anbietern wie GoDaddy, Namecheap oder Google Domains).`)
};

const ja_connect_a_domain_you_already_o = /** @type {(inputs: Connect_A_Domain_You_Already_OInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GoDaddy、Namecheap、Google Domains などのプロバイダーから、すでに所有しているドメインを接続します。`)
};

const zh_connect_a_domain_you_already_o = /** @type {(inputs: Connect_A_Domain_You_Already_OInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连接您已有的域名（如在 GoDaddy、Namecheap 或 Google Domains 等服务商处购买的域名）。`)
};

const ar_connect_a_domain_you_already_o = /** @type {(inputs: Connect_A_Domain_You_Already_OInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اربط نطاقًا تملكه بالفعل (من مزودين مثل GoDaddy، Namecheap، أو Google Domains).`)
};

const id_connect_a_domain_you_already_o = /** @type {(inputs: Connect_A_Domain_You_Already_OInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungkan domain yang sudah Anda miliki dari penyedia seperti GoDaddy, Namecheap, atau Google Domains.`)
};

const it_connect_a_domain_you_already_o = /** @type {(inputs: Connect_A_Domain_You_Already_OInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collega un dominio che già possiedi (da provider come GoDaddy, Namecheap o Google Domains).`)
};

const ru_connect_a_domain_you_already_o = /** @type {(inputs: Connect_A_Domain_You_Already_OInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключите домен, которым вы уже владеете (от провайдеров вроде GoDaddy, Namecheap или Google Domains).`)
};

const pt_connect_a_domain_you_already_o = /** @type {(inputs: Connect_A_Domain_You_Already_OInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecte um domínio que você já possui (de provedores como GoDaddy, Namecheap ou Google Domains).`)
};

const ko_connect_a_domain_you_already_o = /** @type {(inputs: Connect_A_Domain_You_Already_OInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미 소유하고 있는 도메인(GoDaddy, Namecheap 또는 Google Domains와 같은 제공업체)을 연결합니다.`)
};

/**
* | output |
* | --- |
* | "Connect a domain you already own from providers like GoDaddy, Namecheap, or Google Domains." |
*
* @param {Connect_A_Domain_You_Already_OInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const connect_a_domain_you_already_o = /** @type {((inputs?: Connect_A_Domain_You_Already_OInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connect_A_Domain_You_Already_OInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_connect_a_domain_you_already_o(inputs)
	if (locale === "es") return es_connect_a_domain_you_already_o(inputs)
	if (locale === "fr") return fr_connect_a_domain_you_already_o(inputs)
	if (locale === "de") return de_connect_a_domain_you_already_o(inputs)
	if (locale === "ja") return ja_connect_a_domain_you_already_o(inputs)
	if (locale === "zh") return zh_connect_a_domain_you_already_o(inputs)
	if (locale === "ar") return ar_connect_a_domain_you_already_o(inputs)
	if (locale === "id") return id_connect_a_domain_you_already_o(inputs)
	if (locale === "it") return it_connect_a_domain_you_already_o(inputs)
	if (locale === "ru") return ru_connect_a_domain_you_already_o(inputs)
	if (locale === "pt") return pt_connect_a_domain_you_already_o(inputs)
	return ko_connect_a_domain_you_already_o(inputs)
});